import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

declare global {
    interface Window {
        dataLayer: object[];
    }
}

export interface IGoogleTagManagerConfig {
    /** GTM container ID */
    containerId?: string;
    /** GTM script ID (default: "325iahfwyhtc") */
    scriptId?: string;
    /** GTM script parameters (default: "4fckz=ChBVPiMrRSxRM1s%2FTjJOF15GRkhRAgZcEQ0GHBwWAQQRAwcNGR9GEQ8%3D") */
    scriptParams?: string;
    /** GTM base URL (default: "https://gtm.rynekpierwotny.pl") */
    gtmUrl?: string;
    /** GTM load URL for non-Safari browsers (default: "https://load.gtm.rynekpierwotny.pl") */
    gtmLoadUrl?: string;
    /** UID source type (default: "stapeUserId") */
    uidSource?: string;
    /** UID value/key (default: "") */
    uidValue?: string;
    /** UID attribute (default: "") */
    uidAttr?: string;
}

let isGtmInitialized = false;

/**
 * Loads and initializes Google Tag Manager
 * @param config Configuration object for GTM initialization
 */
export const loadGoogleTagManager = (config: IGoogleTagManagerConfig): void => {
    if (!config.containerId) {
        return;
    }

    if (process.env.EXEC_ENV !== "browser" && typeof window === "undefined") {
        return;
    }
    // initialize only once
    if (isGtmInitialized) {
        return;
    }

    (function () {
        "use strict";

        const getCookie = (key: string): string | undefined => {
            const cookies = document.cookie.split(";");
            for (const cookie of cookies) {
                const [name, value] = cookie.split("=");
                if (name.trim() === key) {
                    return value;
                }
            }
            return undefined;
        };

        const getLocalStorage = (key: string): string | null => {
            return localStorage.getItem(key);
        };

        const getWindowVar = (key: string): unknown => {
            return (window as unknown as Window & Record<string, unknown>)[key];
        };

        const getFromSelector = (selector: string, attribute?: string): string | null | undefined => {
            const element = document.querySelector(selector);
            if (!element) {
                return undefined;
            }
            return attribute ? element.getAttribute(attribute) : element.textContent;
        };

        const w = window;
        const d = document;
        const SCRIPT_TAG = "script";
        const DATA_LAYER_KEY = "dataLayer";
        const GTM_URL = config.gtmUrl || "https://gtm.rynekpierwotny.pl";
        const GTM_LOAD_URL = config.gtmLoadUrl || "https://load.gtm.rynekpierwotny.pl";
        let scriptId = config.scriptId || "325iahfwyhtc";
        const scriptParams = config.scriptParams || "4fckz=ChBVPiMrRSxRM1s%2FTjJOF15GRkhRAgZcEQ0GHBwWAQQRAwcNGR9GEQ8%3D";
        const uidSource = config.uidSource || "stapeUserId";
        const uidValue = config.uidValue || "";
        const uidAttr = config.uidAttr || "";
        let isSafari16_4 = false;

        try {
            const userAgent = navigator.userAgent;
            const safariMatch = /Version\/([0-9._]+)(.*Mobile)?.*Safari.*/.exec(userAgent);
            const isSafari = !!safariMatch && parseFloat(safariMatch[1]) >= 16.4;
            const isStapeId = uidSource === "stapeUserId";

            const uidSources: Record<string, (key: string, attr?: string) => string | null | undefined> = {
                cookie: getCookie,
                localStorage: getLocalStorage,
                jsVariable: getWindowVar as (key: string) => string | undefined,
                cssSelector: getFromSelector
            };

            const getUid = (source: string, key: string | string[], attr?: string): string | undefined => {
                const keys = Array.isArray(key) ? key : [key];
                const fn = uidSources[source];
                if (!fn) {
                    console.warn("invalid uid source", source);
                    return;
                }
                for (const k of keys) {
                    const value = attr ? fn(k, attr) : fn(k);
                    if (value) {
                        return value;
                    }
                }
                return undefined;
            };

            const I = isSafari && !isStapeId ? getUid(uidSource, uidValue, uidAttr) : undefined;

            isSafari16_4 = isSafari && (!!I || isStapeId);

            const dataLayer = ((w as Window)[DATA_LAYER_KEY] = (w as Window)[DATA_LAYER_KEY] || []);
            dataLayer.push({"gtm.start": Date.now(), event: "gtm.js"});

            const firstScript = d.getElementsByTagName(SCRIPT_TAG)[0];
            const biParam = I ? "&bi=" + encodeURIComponent(I) : "";
            const newScript = d.createElement(SCRIPT_TAG) as HTMLScriptElement;

            if (isSafari16_4) {
                scriptId = scriptId.length > 8 ? scriptId.replace(/([a-z]{8}$)/, "kp$1") : "kp" + scriptId;
            }

            const baseUrl = !isSafari16_4 && GTM_LOAD_URL ? GTM_LOAD_URL : GTM_URL;
            newScript.async = true;
            newScript.src = `${baseUrl}/${scriptId}.js?${scriptParams}${biParam}`;

            const parent = firstScript.parentNode;
            if (parent) {
                parent.insertBefore(newScript, firstScript);
            }
        } catch (err) {
            const errorMsg = `Error in loadGoogleTagManager: ${err}`;

            notifyBugsnagClient(new Error(errorMsg), errorMsg);
        }
    })();

    isGtmInitialized = true;
};
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

declare global {
    interface Window {
        dataLayer: object[];
    }
}

export interface IGoogleTagManagerConfig {
    /** GTM container ID */
    containerId?: string;
    /** GTM script ID (default: "325iahfwyhtc") */
    scriptId?: string;
    /** GTM script parameters (default: "4fckz=ChBVPiMrRSxRM1s%2FTjJOF15GRkhRAgZcEQ0GHBwWAQQRAwcNGR9GEQ8%3D") */
    scriptParams?: string;
    /** GTM base URL (default: "https://gtm.rynekpierwotny.pl") */
    gtmUrl?: string;
    /** GTM load URL for non-Safari browsers (default: "https://load.gtm.rynekpierwotny.pl") */
    gtmLoadUrl?: string;
    /** UID source type (default: "stapeUserId") */
    uidSource?: string;
    /** UID value/key (default: "") */
    uidValue?: string;
    /** UID attribute (default: "") */
    uidAttr?: string;
}

let isGtmInitialized = false;

/**
 * Loads and initializes Google Tag Manager
 * @param config Configuration object for GTM initialization
 */
export const loadGoogleTagManager = (config: IGoogleTagManagerConfig): void => {
    if (!config.containerId) {
        return;
    }

    if (process.env.EXEC_ENV !== "browser" && typeof window === "undefined") {
        return;
    }
    // initialize only once
    if (isGtmInitialized) {
        return;
    }

    (function () {
        "use strict";

        const getCookie = (key: string): string | undefined => {
            const cookies = document.cookie.split(";");
            for (const cookie of cookies) {
                const [name, value] = cookie.split("=");
                if (name.trim() === key) {
                    return value;
                }
            }
            return undefined;
        };

        const getLocalStorage = (key: string): string | null => {
            return localStorage.getItem(key);
        };

        const getWindowVar = (key: string): unknown => {
            return (window as unknown as Window & Record<string, unknown>)[key];
        };

        const getFromSelector = (selector: string, attribute?: string): string | null | undefined => {
            const element = document.querySelector(selector);
            if (!element) {
                return undefined;
            }
            return attribute ? element.getAttribute(attribute) : element.textContent;
        };

        const w = window;
        const d = document;
        const SCRIPT_TAG = "script";
        const DATA_LAYER_KEY = "dataLayer";
        const GTM_URL = config.gtmUrl || "https://gtm.rynekpierwotny.pl";
        const GTM_LOAD_URL = config.gtmLoadUrl || "https://load.gtm.rynekpierwotny.pl";
        let scriptId = config.scriptId || "325iahfwyhtc";
        const scriptParams = config.scriptParams || "4fckz=ChBVPiMrRSxRM1s%2FTjJOF15GRkhRAgZcEQ0GHBwWAQQRAwcNGR9GEQ8%3D";
        const uidSource = config.uidSource || "stapeUserId";
        const uidValue = config.uidValue || "";
        const uidAttr = config.uidAttr || "";
        let isSafari16_4 = false;

        try {
            const userAgent = navigator.userAgent;
            const safariMatch = /Version\/([0-9._]+)(.*Mobile)?.*Safari.*/.exec(userAgent);
            const isSafari = !!safariMatch && parseFloat(safariMatch[1]) >= 16.4;
            const isStapeId = uidSource === "stapeUserId";

            const uidSources: Record<string, (key: string, attr?: string) => string | null | undefined> = {
                cookie: getCookie,
                localStorage: getLocalStorage,
                jsVariable: getWindowVar as (key: string) => string | undefined,
                cssSelector: getFromSelector
            };

            const getUid = (source: string, key: string | string[], attr?: string): string | undefined => {
                const keys = Array.isArray(key) ? key : [key];
                const fn = uidSources[source];
                if (!fn) {
                    console.warn("invalid uid source", source);
                    return;
                }
                for (const k of keys) {
                    const value = attr ? fn(k, attr) : fn(k);
                    if (value) {
                        return value;
                    }
                }
                return undefined;
            };

            const I = isSafari && !isStapeId ? getUid(uidSource, uidValue, uidAttr) : undefined;

            isSafari16_4 = isSafari && (!!I || isStapeId);

            const dataLayer = ((w as Window)[DATA_LAYER_KEY] = (w as Window)[DATA_LAYER_KEY] || []);
            dataLayer.push({"gtm.start": Date.now(), event: "gtm.js"});

            const firstScript = d.getElementsByTagName(SCRIPT_TAG)[0];
            const biParam = I ? "&bi=" + encodeURIComponent(I) : "";
            const newScript = d.createElement(SCRIPT_TAG) as HTMLScriptElement;

            if (isSafari16_4) {
                scriptId = scriptId.length > 8 ? scriptId.replace(/([a-z]{8}$)/, "kp$1") : "kp" + scriptId;
            }

            const baseUrl = !isSafari16_4 && GTM_LOAD_URL ? GTM_LOAD_URL : GTM_URL;
            newScript.async = true;
            newScript.src = `${baseUrl}/${scriptId}.js?${scriptParams}${biParam}`;

            const parent = firstScript.parentNode;
            if (parent) {
                parent.insertBefore(newScript, firstScript);
            }
        } catch (err) {
            const errorMsg = `Error in loadGoogleTagManager: ${err}`;

            notifyBugsnagClient(new Error(errorMsg), errorMsg);
        }
    })();

    isGtmInitialized = true;
};
